<template>
  <div data-qa="userprofile-div-urhb6a">
    <v-menu :close-on-content-click="true" offset-y data-qa="userprofile-menu-o8oufw">
      <template v-slot:activator="{ on }">
        <v-btn
          icon
          @click="showUserProfile = !showUserProfile"
          v-on="on"
         data-qa="userprofile-btn-dq2tjq">
          <!-- <v-icon :color="onSurfaceMedium" data-qa="userprofile-icon-ecsojq">mdi-account-outline</v-icon> -->
          <v-avatar :color="primaryColor" class="nav__header-avatar" size="40" data-qa="userprofile-avatar-jhbsl">
            <span data-qa="userprofile-span-33z31m">
              <v-list-item-title class="text-h6" data-qa="userprofile-list-item-title-eajr4k">{{
                sessionActiveUserInitial
              }}</v-list-item-title>
            </span>
          </v-avatar>
        </v-btn>
      </template>
      <v-card data-qa="userprofile-card-ah5zl">
        <v-card-title class="justify-space-around py-2 px-0 pl-2" data-qa="userprofile-card-title-gib2k">
          <v-avatar :color="primaryColor" class="nav__header-avatar" size="50" data-qa="userprofile-avatar-pt9md">
            <span data-qa="userprofile-span-jsqiy7">
              <v-list-item-title class="text-h6" data-qa="userprofile-list-item-title-to1rhb">{{
                sessionActiveUserInitial
              }}</v-list-item-title>
            </span>
          </v-avatar>
          <v-list-item-content class="pl-4" data-qa="userprofile-list-item-content-6pm6x9">
            <v-list-item-title
               data-qa="userprofile-list-item-title-q0o63"><font class="subtitle-1 font-weight-bold text-uppercase">{{
                sessionActiveUserName
              }}</font></v-list-item-title
            >
            <v-list-item-subtitle v-if="showCustomerSegment" data-qa="userprofile-list-item-subtitle-axbv83">
              <font class="caption font-weight-light text-capitalize">{{
                sessionActiveSegment
              }}</font></v-list-item-subtitle
            >
            <v-list-item-subtitle v-if="lastLoginTimeStamp" data-qa="userprofile-list-item-subtitle-kzd4m">
              <font class="caption font-weight-light text-capitalize" :color="primaryColor">
              {{ $t("userProfile.lastLoginTime") }}
              {{ $formatter.formatDateTime(lastLoginTimeStamp, { local: true }) }}
              </font></v-list-item-subtitle
            >
          </v-list-item-content>
        </v-card-title>
        <v-divider data-qa="userprofile-divider-m5h7tm"></v-divider>
        <v-list data-qa="userprofile-list-ncej69">
          <div v-for="(item,i) in menuStructure" :key="item.title" class="px-1" :data-qa="`userprofile-div-2j8v1-${i}`">
            <v-list-item
              v-if="item.enable"
              link
              v-bind:to="item.path"
              :color="primaryColor"
              :data-qa="`userprofile-list-item-8uwcif-${i}`">
              <!-- <inline-svg
                v-if="item.svgIcon"
                :src="getNavigationIcon(item.svgIcon)"
                width="25"
                height="25"
                aria-label="Navigation Icon"
              ></inline-svg>
              <v-icon v-if="item.icon" :color="onSurfaceMedium" :data-qa="`userprofile-icon-5v87y9-${i}`">{{
                item.icon
              }}</v-icon> -->
              <dob-icon :iconKey="item.icon" />
              <v-flex class="pl-4" :data-qa="`userprofile-flex-pc41ad-${i}`"></v-flex>
              <v-list-item-title :to="item.path" :data-qa="`userprofile-list-item-title-1c3jo-${i}`">
                <font class="body-2 font-weight-bold">{{ item.title }}</font>
              </v-list-item-title>
            </v-list-item>
          </div>
        </v-list>

        <v-divider data-qa="userprofile-divider-n1d6ya"></v-divider>

        <v-list data-qa="userprofile-list-t4hxru">
          <v-list-item class="justify-space-around" data-qa="userprofile-list-item-u8wxu">
            <v-row align="center" justify="center" data-qa="userprofile-row-or9kvo">
              <div class="text-center" data-qa="userprofile-div-gw3xk">
                <v-btn
                  @click="logoutConfirm"
                  :color="primaryColor"
                  dark
                  small
                  height="36px"
                  class="nav__logout-btn text-none body-1 py-2 px-4"
                 data-qa="userprofile-btn-r0q0tt">
                <v-icon size="18px" class="px-2 material-symbols-outlined" data-qa="userprofile-icon-5fui8">
                  logout
                </v-icon>
                  {{ $t("common.logoutText") }}
                </v-btn>
              </div>
            </v-row>
          </v-list-item>
        </v-list>
      </v-card>
    </v-menu>
    <Modal :config="modalConfig" @btn1Action="logout">
      <span slot="modalContent" data-qa="userprofile-span-9wi4er">
        {{ $t("common.confirmation_message") }}
      </span>
    </Modal>
  </div>
</template>

<script>
import store from '@/core/store'
import event from '@/util/event'

export default {
  components: {
    Modal: () => import('@/components/common/Modal.vue')
  },
  computed: {
    menuStructure () {
      return [
        {
          icon: 'userprofile_myprofile',
          title: this.$t('userProfile.menuStructureTitle.myProfile'),
          path: '/myProfile',
          name: 'MyProfile',
          enable: true
        },
        {
          icon: 'userprofile_settings',
          title: this.$t('userProfile.menuStructureTitle.settings'),
          path: '/settings',
          name: 'Settings',
          enable: true
        },
        {
          icon: 'userprofile_changepassword',
          title: this.$t('userProfile.menuStructureTitle.changePassword'),
          path: '/changePassword',
          name: 'ChangePassword',
          enable: true
        }
      ]
    }
  },
  data () {
    return {
      modalConfig: {
        enabled: false,
        persistent: true,
        title: this.$t('common.logoutText'),
        btn2Label: this.$t('common.no'), // No Button
        btn1Label: this.$t('common.yes'), // Yes Button
        outlinedSaveBtn: true,
        outlinedCancelBtn: false,
        width: 400
      },

      showUserProfile: false,
      sessionActiveUserInitial: '',
      sessionActiveUserName: '',
      sessionActiveUserEmail: '',
      sessionActiveSegment: '',
      lastLoginTimeStamp: '',
      showCustomerSegment:
        this.$appSettings.defaultConfigurations.myProfileScreen
          .showCustomerSegment
    }
  },
  created () {
    this.lastLoginTimeStamp = JSON.parse(sessionStorage.getItem('lastLoginTimeStamp'))
    this.getCustomerData()
  },
  mounted () {
    this.getCustomerData()
  },
  methods: {
    getNavigationIcon (icon) {
      return this.getSvgIconSrc(icon)
    },
    getCustomerData () {
      const data = store.getters['profileStore/profileData'].customerDetails
      if (data) {
        this.sessionActiveUserName = data.smeRelationshipDetails.relatedPartyName || 'Roger Moore'
        this.sessionActiveUserEmail =
          data.emailAddress || 'someemail@finastra.com'
          const userSegment = !this.isSmeLogin ? data.smeSegmentKYCDetails.segmentCategoryDescription : data.segmentCategoryDesc
          this.sessionActiveSegment =  `${userSegment} Customer`
          
        const initialArray = data.smeRelationshipDetails.relatedPartyName.split(' ')
        if (initialArray.length > 0) {
          this.sessionActiveUserInitial = ''
          for (let index = 0; index < initialArray.length; index++) {
            this.sessionActiveUserInitial = this.sessionActiveUserInitial.concat(
              initialArray[index].charAt(0)
            )
          }
        } else {
          this.sessionActiveUserInitial = 'RM'
        }
      }
    },
    handleDrawerEvent (event) {
      this.drawer = event
    },
    logout () {
      event.$emit('depositPristineLogout', true)
      this.$logoutSetting.methods.systemLogout()
      // this.$router.push('/login')
    },
    logoutConfirm () {
      this.modalConfig.enabled = true
    },
    showDialog () {
      this.drawer = false
      return (this.dialog = true)
    }
  },
  watch: {
    showUserProfile () {
      event.$emit('open_userProfile', true)
    },
    '$vuetify.breakpoint.name': {
      handler () {
        this.showUserProfile = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.underlined-cursor-pointer {
  cursor: pointer;
  text-decoration: underline;
}
.v-list-item--active::before {
  border-radius: 8px;
}

.v-list-item {
  &:not(.v-list-item--active) {
    .v-list-item__title {
      color: $onSurfaceMedium;
    }
  }
}
</style>
